import { GridComparatorFn } from '@mui/x-data-grid'

export const getElementName = (
  identifyingInformation:
    | {
        [key: string]: string | number
      }
    | null
    | undefined,
  defaultIfNull = '',
): string | null => {
  // Elements don't share standard fields across clients
  // so this finds the first available field and returns.
  // Be prepared to keep adding to the below and be aware
  // the order matters
  const address = identifyingInformation
    ? (identifyingInformation['Address'] ??
      identifyingInformation['Address(es)'] ??
      identifyingInformation['Road Id'] ??
      identifyingInformation['Name'] ??
      identifyingInformation['Description'] ??
      identifyingInformation['State highway'] ??
      identifyingInformation['Location name'] ??
      identifyingInformation['Asset number'] ??
      null)
    : null

  if (address) return address.toString()
  return defaultIfNull
}

export const getClientAssetId = (
  identifyingInformation:
    | {
        [key: string]: string | number
      }
    | null
    | undefined,
  defaultIfNull = '',
): string | number | null => {
  if (identifyingInformation && identifyingInformation['Asset ID'])
    return identifyingInformation['Asset ID']

  return defaultIfNull
}

export const exposureComparator: GridComparatorFn<string> = (v1, v2) => {
  // All strings are equal, numbers are greater than strings.
  const n1 = Number.parseFloat(v1)
  const n2 = Number.parseFloat(v2)
  if (!Number.isNaN(n1) && !Number.isNaN(n2)) return n1 - n2
  if (!Number.isNaN(n1)) return 1
  if (!Number.isNaN(n2)) return -1
  return 0
}
